const  generateVideoSchema = (tileType) =>{
    // Define video details for each tile type
    const videoData = {
      "wall-tiles": {
        videoLink: "https://www.youtube.com/watch?v=zQLDurlHrNw",
        name: "How to Install Wall Tiles - Step-by-Step Guide",
        description:
          "Discover the expert step-by-step process for installing wall tiles in this detailed guide. Learn how to improve the aesthetic appeal and durability of your walls with trending tiles.",
        thumbnailUrl: "https://img.youtube.com/vi/zQLDurlHrNw/maxresdefault.jpg",
        uploadDate: "2021-04-26T07:15:44Z",
        duration: "PT14M27S",
        interactionCount: 9863,
      },
      "bathroom-tiles": {
        videoLink: "https://www.youtube.com/watch?v=zomjakM68Rs",
        name: "Guide to Choosing the Best Bathroom Tiles",
        description:
          "Explore the art of selecting the perfect bathroom tiles to create a serene and functional space. Discover various sizes, colors, and designs to suit your dream bathroom. Watch now to learn tips for selecting the right bathroom tiles for walls and floors!",
        thumbnailUrl: "https://i.ytimg.com/vi/zomjakM68Rs/default.jpg",
        uploadDate: "2021-01-19T12:17:44Z",
        duration: "PT2M9S",
        interactionCount: 45195,
      },
    };
  
    // Check for valid tileType
    const videoDetails = videoData[tileType];
    if (!videoDetails) {
        return JSON.stringify({});
    }
  
    // Construct schema
    const pageUrl = `https://www.orientbell.com/tiles/${tileType}`;
    const schema = {
      "@context": "https://schema.org",
      "@type": "VideoObject",
      "name": videoDetails.name,
      "description": videoDetails.description,
      "thumbnailUrl": videoDetails.thumbnailUrl,
      "uploadDate": videoDetails.uploadDate,
      "duration": videoDetails.duration,
      "contentUrl": pageUrl,
      "embedUrl": `https://www.youtube.com/embed/${
        videoDetails.videoLink.split("v=")[1]
      }`,
      "publisher": {
        "@type": "Organization",
        "name": "Orientbell Tiles",
        "logo": {
          "@type": "ImageObject",
          "url": "https://server.orientbell.com/media/img/logo-white.png",
        },
      },
      "author": {
        "@type": "Person",
        "name": "Orientbell Tiles",
      },
      "interactionStatistic": {
        "@type": "InteractionCounter",
        "interactionType": "https://schema.org/WatchAction",
        "userInteractionCount": videoDetails.interactionCount,
      },
    };
  
    return JSON.stringify(schema);
  }


  module.exports=generateVideoSchema